import { render } from "./SchemeForm.vue?vue&type=template&id=78f8cd84&ts=true"
import script from "./SchemeForm.vue?vue&type=script&lang=ts"
export * from "./SchemeForm.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/inputs/form/SchemeForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78f8cd84"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78f8cd84', __exports__)) {
    api.reload('78f8cd84', __exports__)
  }
  
  module.hot.accept("./SchemeForm.vue?vue&type=template&id=78f8cd84&ts=true", () => {
    api.rerender('78f8cd84', render)
  })

}


export default __exports__